import $ from 'jquery';

export default class UserFreightRatesImport {
  constructor($scope, $rootScope, FileUploader) {
    $scope.set_uploaders = function() {
      var f = new FileUploader({
        url: '/admin/marketplace/users/import_user_freight_rates',
        formData: [{
          authenticity_token: window.token,
          user_id: window.user_id
        }],
        removeAfterUpload: true
      });
      f.file_element = 'upload_file';
      f.onBeforeUploadItem = function(/*item*/) {
        f.processing = true;
      };
      f.onCompleteItem = function(fileItem, response/*, status, headers*/) {
        if (response.success) {
          f.processing = false;
          f.clearQueue();
          $('input.' + f.file_element).val(null);
          $rootScope.$broadcast('load_freight_rates');
        }
      };
      $scope.uploader = f;
    };

    $scope.init = function() {
      $scope.set_uploaders();
    };

    $scope.init();
  }
}

UserFreightRatesImport.$inject = ['$scope', '$rootScope', 'FileUploader'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-freight-rates-import.js